import { Input } from "@/app/admin/_common/ui/input";
import ShowFilter from "@/app/admin/orders/_cmp/ShowFilter";
import { Search } from "lucide-react";

export default function PromoOrdersToolbar({
  search,
  onSearchChange,
  showIds,
  onShowIdsChange,
}: {
  search: string;
  onSearchChange: (value: string) => void;
  showIds: string[];
  onShowIdsChange: (ids: string[]) => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative max-w-[420px] flex-1">
        <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center">
          <Search className="size-3.5 text-muted-foreground" />
        </div>
        <Input
          type="search"
          placeholder="Search guest, email or order…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="h-[30px] pl-9 text-[12.5px]"
          aria-label="Search orders"
        />
      </div>

      <ShowFilter selectedShowIds={showIds} onChange={onShowIdsChange} />
    </div>
  );
}
